import { render } from "./content-header.html?vue&type=template&id=c36f8b62&scoped=true&ts=true"
import script from "./content-header.ts?vue&type=script&lang=ts"
export * from "./content-header.ts?vue&type=script&lang=ts"

import "./content-header.scss?vue&type=style&index=0&id=c36f8b62&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36f8b62"]])

export default __exports__